import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { PageContainer } from "../../components/page_container/PageContainer";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { selectState } from "./AboutUsSlice";
import { SideMenuPageContainer } from "../../components/side_menu_page_container/SideMenuPageContainer";
import { Box, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export function AboutUs() {
  const dispatch = useAppDispatch();
  const state = useAppSelector(selectState);
  const { t } = useTranslation();

  return (
    <SideMenuPageContainer
      pageTitle={t("aboutUs.title")}
      pageSeoTitle={t("aboutUs.seoTitle")}
      pageDescription={t("aboutUs.description")}
    >
      <Box sx={{ width: { xs: 300, sm: 350, md: 600, lg: 700 } }}>
        <Grid2
          container
          spacing={2}
          sx={{ mt: 2 }}
          columns={{ xs: 6, sm: 6, md: 12, lg: 12 }}
        >
          <Grid2 xs={12}>
            <Typography variant="h2" sx={{ mb: 2 }}>
              {t("aboutUs.mainHeading")}
            </Typography>
          </Grid2>
          <Grid2 xs={12}>
            <Typography variant="body1" sx={{ mb: 0.5 }}>
              {t("aboutUs.content.mission")}
            </Typography>
          </Grid2>
          <Grid2 xs={12}>
            <Typography variant="body1" sx={{ mb: 0.5 }}>
              {t("aboutUs.content.feedback")}
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              <a href="mailto:hi@cvstrydom.co.za">hi@cvstrydom.co.za</a>
            </Typography>
          </Grid2>
        </Grid2>
      </Box>
    </SideMenuPageContainer>
  );
}
